import { Component, OnInit } from '@angular/core';
import {OPERATIONINFO} from '../../../gen/swagger-api/model/oPERATIONINFO';
import {APIOPERATIONINFO} from '../../../gen/swagger-api/model/aPIOPERATIONINFO';

@Component({
  selector: 'app-operation-info-view',
  templateUrl: './operation-info-view.component.html',
  styleUrls: ['./operation-info-view.component.css']
})
export class OperationInfoViewComponent implements OnInit {
  operationInfo: APIOPERATIONINFO;

  constructor() { }

  ngOnInit() {
  }

  copyOperationInfo()
  {
    var text = "";
    if (this.operationInfo.dpInfo)
    {
      text += "DP Operation Info\n";
      text = this.operationInfoToText(this.operationInfo.dpInfo) + "\n";
    }
    text += "SR Operation Info\n"
    text += this.operationInfoToText(this.operationInfo.srInfo);
    if (this.operationInfo.srInfo.traceId)
    {
      text += "TraceID: " + this.operationInfo.srInfo.traceId;
    }

    this.copyToClipboard(text);
  }

  copyTraceId(event: MouseEvent)
  {
    var text = this.operationInfo.srInfo.traceId;
    this.copyToClipboard(text);
    event.stopPropagation();
  }

  onLoad(operationInfo: APIOPERATIONINFO)
  {
     this.operationInfo = operationInfo;
  }

  operationInfoToText(info: OPERATIONINFO)
  {
     var text;
     text = "Started: " + info.started + "\n";
     text += "Type: " + info.operationType + "\n";
     if (info.requestInterface)
     {
       text += "Interface: " + info.requestInterface + "\n";
     }
     if (info.currentOperationState)
     {
       text += "State: " + info.currentOperationState + "\n";
     }
     if (info.expires)
     {
       text += "Expires: " + info.expires + "\n";
     }
     if (info.statusCode)
     {
       text += "Status Code: " + info.statusCode + "\n";
     }
     if (info.subjectCode)
     {
       text += "Subject Code: " + info.subjectCode + "\n";
     }
     if (info.reasonCode)
     {
       text += "Reason Code: " + info.reasonCode + "\n";
     }
     if (info.statusMessage)
     {
       text += "Message: " + info.statusMessage + "\n";
     }
     if (info.lastState)
     {
       text += "Last state: " + info.lastState + "\n";
     }
     return text;
  }

  // small utility function to copy random text to clipboard
  copyToClipboard(val: string)
  {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/operation-info-view/operation-info-view.component.ts